export default __webpack_public_path__ + "static/media/AnglingText.e10923ee.gif";